/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineScopeGlobal extends models.TagBaselineScope {
    constructor() {
        super();
        this.setDiscriminator("TagBaselineScopeGlobal");
    }

    getFixupPrototypeFunction() { return TagBaselineScopeGlobal.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineScopeGlobal>): TagBaselineScopeGlobal {
        let obj = Object.assign(new TagBaselineScopeGlobal(), model);
        TagBaselineScopeGlobal.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineScopeGlobal>): TagBaselineScopeGlobal {
        if (!model) return null;
        return TagBaselineScopeGlobal.newInstance(<TagBaselineScopeGlobal> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineScopeGlobal) {
        if (!obj) return;

        models.TagBaselineScopeGlobal.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineScopeGlobal): boolean {
        if (models.TagBaselineScope.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineScopeGlobal.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
